import List from '@/components/InspectionReport/Items/Questions/List.vue';
import Dropdown from '@/components/InspectionReport/Items/Questions/Dropdown';
import Checkbox from '@/components/InspectionReport/Items/Questions/Checkbox';
import Text from '@/components/InspectionReport/Items/Questions/Text';
import NumberQuestion from '@/components/InspectionReport/Items/Questions/Number';
import Datetime from '@/components/InspectionReport/Items/Questions/Datetime';
import Photo from '@/components/InspectionReport/Items/Questions/Photo';
import Annotation from '@/components/InspectionReport/Items/Questions/Annotation';
import Signature from '@/components/InspectionReport/Items/Questions/Signature';
import Instruction from '@/components/InspectionReport/Items/Questions/Instruction';
import ConductedBy from '@/components/InspectionReport/Items/Questions/ConductedBy';
import ConductedAt from '@/components/InspectionReport/Items/Questions/ConductedAt';
import Site from '@/components/InspectionReport/Items/Questions/Site';
import UnknownQuestion from '@/components/InspectionReport/Items/Questions/UnknownQuestion.vue';
import Action from '@/components/InspectionReport/Items/Action';

function shouldDisplay(item, resource) {
    if (item.response_type === 'instruction') {
        if (resource.template.exclude_questions_type_instruction) {
            return false;
        }
        return true;
    }

    if (!item.params || (item.params && item.params.automatic !== true)) { // exclude automatic items
        if (resource.template.exclude_questions_not_responded
            && item.responded !== true
        ) {
            return false;
        }
    }

    return true;
}

function resolvedQuestionType(item, resource) {
    switch (item.response_type) {
        case 'list': {
            const responseSet = resource.form.params.response_sets.find(
                ({ uuid }) => uuid === item.params.response_set,
            );
            switch (responseSet.type) {
                case 'dropdown':
                    return Dropdown;
                case 'list':
                default:
                    return List;
            }
        }
        case 'text':
            return Text;
        case 'number':
            return NumberQuestion;
        case 'checkbox':
            return Checkbox;
        case 'datetime':
            return Datetime;
        case 'photo':
            return Photo;
        case 'annotation':
            return Annotation;
        case 'signature':
            return Signature;
        case 'instruction':
            return Instruction;
        case 'user_automatic':
            return ConductedBy;
        case 'datetime_automatic':
            return ConductedAt;
        case 'site_automatic':
            return Site;
        default:
            return UnknownQuestion;
    }
}

export default {
    name: 'Question',
    functional: true,
    props: {
        item: {
            type: Object,
            required: true,
        },
        resource: {
            type: Object,
            required: true,
        },
        withIssues: {
            type: Boolean,
            default: true,
        },
    },
    render(h, { props, parent }) {
        if (shouldDisplay(props.item, props.resource)) {
            const inFormIssue = props.resource.issues
                && props.withIssues
                && props.resource.template.display_issues
                && props.resource.issues.find((issue) => issue.payload.item_uuid === props.item.uuid);

            return [
                h(resolvedQuestionType(props.item, props.resource), {
                    class: `pt-3 question ${!inFormIssue && 'pb-3'}`,
                    props,
                }),
                inFormIssue
                && h('div', { class: 'py-3 flex flex-col action' }, [
                    h('span', { class: 'text-70 mb-1' }, parent.$t('Issue')),
                    h(Action, {
                        props: {
                            item: inFormIssue,
                            displayQuery: false,
                        },
                    }),
                ]),
            ];
        }
        return null;
    },
};
